import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthRoutingModule } from './auth-routing.module';
import { SigninComponent } from "../authentication/signin/signin.component";
import { AuthenticationComponent } from "../authentication/authentication.component";
import {
  MatToolbarModule, MatButtonModule, MatSidenavModule, MatIconModule, MatCardModule, MatSnackBarModule,
  MatListModule, MatMenuModule, MatBadgeModule, MatFormFieldModule, MatInputModule, MatCheckboxModule,
  MatTableModule, MatTabsModule, MatPaginatorModule, MatSelectModule, MatDialogModule,MatSlideToggleModule
} from '@angular/material';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
@NgModule({
  declarations: [
    AuthenticationComponent,
    SigninComponent,
  ],
  imports: [
    FormsModule,ReactiveFormsModule,
    CommonModule,MatToolbarModule, MatButtonModule, MatSidenavModule, MatIconModule, MatCardModule, MatSnackBarModule,
    MatListModule, MatMenuModule, MatBadgeModule, MatFormFieldModule, MatInputModule, MatCheckboxModule,
    MatTableModule, MatTabsModule, MatPaginatorModule, MatSelectModule, MatDialogModule,MatSlideToggleModule,
    AuthRoutingModule,
  ]
})
export class AuthenticationModule { }
